/// <amd-module name="Release/DeletedPipelines/Store" />

import { StoreBase } from "DistributedTask/Flux/Store";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { Actions as DeletedPipelineActions, IDeletedPipelinesListPayload } from "./Actions";
import { IDeletedDefinitionReference } from "./DeletedPipelinesData";

export interface IDeletedPipelinesListState extends IDeletedPipelinesListPayload {
    selectedPipeline: IDeletedDefinitionReference | null;
}

export class DeletedPipelinesStore extends StoreBase {
    public static getKey(): string {
        return "rm-del-pipelines-store";
    }

    public initialize(): void {
        this._state = { pipelines: [], isLoading: true, selectedPipeline: null };
        this._actions = ActionsHubManager.GetActionsHub<DeletedPipelineActions>(DeletedPipelineActions);
        this._actions.fetchDeletedPipelines.addListener(this._onPipelinesFetch);
        this._actions.selectPipeline.addListener(this._selectPipeline);
        this._actions.handleUndelete.addListener(this._handleUndelete);
    }

    protected disposeInternal(): void {
        this._actions.fetchDeletedPipelines.removeListener(this._onPipelinesFetch);
        this._actions.selectPipeline.removeListener(this._selectPipeline);
        this._actions.handleUndelete.removeListener(this._handleUndelete);
    }

    public getState(): IDeletedPipelinesListState {
        return this._state;
    }

    private _onPipelinesFetch = (payload: IDeletedPipelinesListPayload) => {
        this._state.pipelines = [...(payload.pipelines || [])];
        this._state.isLoading = payload.isLoading;
        if (this._state.pipelines.length) {
            this._state.selectedPipeline = this._state.pipelines[0];
        }
        this.emitChanged();
    }

    private _selectPipeline = (payload: IDeletedDefinitionReference) => {
        this._state.selectedPipeline = payload;
        this.emitChanged();
    }

    private _handleUndelete = (payload: number) => {
        const index = this._state.pipelines.findIndex(p => p.id === payload);
        if (index >= 0) {
            this._state.pipelines.splice(index, 1);
            if (index >= 1) {
                this._state.selectedPipeline = this._state.pipelines[index - 1];
            }
            else if (this._state.pipelines.length) {
                this._state.selectedPipeline = this._state.pipelines[0];
            }
            else {
                this._state.selectedPipeline = null;
            }

            this.emitChanged();
        }
    }

    private _actions: DeletedPipelineActions;
    private _state: IDeletedPipelinesListState;
}
